// request to source follow by source type

// REQUEST A SOURE FILE
// [source] input must be async function return promise
export const getSourceFile = async (source, config) => {
  const result = await source()
  // because source file has not computed paginate like server
  // we should make local calcualte
  const { limit, page } = config.paginate
  const from = limit * (page - 1)
  const sortedResult = sortData(result, config.paginate.sort.field, config.paginate.sort.order)
  var searchResult = [...sortedResult]
  if(config.search){
    var g = new RegExp(config.search, 'g')
    var getValueList = (n) => Object.values(n).map( (m) => m ? m.toString().toLowerCase() : null)
    searchResult = sortedResult.filter( (row) => {
      var valueList = getValueList(row)
      return valueList.some( (n) => g.test(n))
    })
  }
  const chunk = searchResult.slice(0, from + limit)
  const total = searchResult.length
  
  return {
    total,
    data: chunk,
  }
}

import axios from 'axios'

// REQUEST TO SERVER AND GET DATA
// simple mode: only request and get data back
export const getHttpSimple = async (source, config) => {
  const connection = axios({
    url: source(),
    method: 'POST',
  })

  const result = await connection.then(res => res.data)
  const { limit, page } = config.paginate
  const from = limit * (page - 1)
  const chunk = result.slice(from, from + limit)
  const total = result.length

  return {
    total,
    data: chunk,
  }
}

export const getArray = async (data, config) => {
  const result = data
  const { limit, page } = config.paginate
  const from = limit * (page - 1)
  const sortedResult = sortData(result, config.paginate.sort.field, config.paginate.sort.order)
  var searchResult = [...sortedResult]
  if(config.search){
    var g = new RegExp(config.search, 'g')
    var getValueList = (n) => Object.values(n).map( (m) => m ? m.toString().toLowerCase() : null)
    searchResult = sortedResult.filter( (row) => {
      var valueList = getValueList(row)
      return valueList.some( (n) => g.test(n))
    })
  }
  const chunk = searchResult.slice(0, from + limit)
  const total = searchResult.length
  
  return {
    total,
    data: chunk,
  }
}

const sortData = (data, field, order) => {
  return data.sort((a,b) => {
    let modifier = 1;
    if(order === 'DESC') modifier = -1;
    if(a[field] < b[field]) return -1 * modifier;
    if(a[field] > b[field]) return 1 * modifier;
    return 0;
});
}

// REQUEST TO SERVER AND GET DATA WITH GRAPHQL
// source in this case will be function connect to graphql
// should be vue store function
export const getGraphql = async (source, config, meta, resync = false) => {
  // build ready to use query selector
  let queryVarDefine = `
  $page: Int
  $limit: Int
  $total: Boolean
  $sort: String
  $keyword: String`

  let queryVarUse = `
  page: $page
  limit: $limit
  total: $total
  sort: $sort
  keyword: $keyword`

  // setup params
  const opts = {}

  // add filter query
  const hasFilter = meta && meta.filter
  if (hasFilter) {
    queryVarDefine += ' $filter: Filter'
    queryVarUse += ' filter: $filter'
    opts.filter = meta.filter
  }

  // define list column need for request
  const colMap = config.column_map
  // store field include by main visible column
  const includedColumns = []
  // column visible and allow to query by graph
  const visibleColumns = [...config.visibility].filter(col => {
    const colConfig = colMap[col]
    // if config has in include, we get name of included to
    if (!!colConfig.includes)
      colConfig.includes.map(c => includedColumns.push(c))
    // if current col config not allow to graph
    return colConfig.graph_query
  })

  const selectedColumns = visibleColumns.concat(includedColumns)

  // keyword resolve
  if (config.paginate.keyword) opts.keyword = config.paginate.keyword

  // filter resolve
  if (config.paginate.filter) opts.filter = config.paginate.filter

  // sorting resolve
  const sortResolve = (sortConfig) => {
    const { field, order: orderField } = sortConfig
    // find sorting field from config
    const fieldConfig = config.column_map[field]
    // force select this field in query
    // only if field allow in graph
    if (fieldConfig.graph_query) selectedColumns.push(field)
    // convert to graphql sorting string
    const sortField = fieldConfig.sorting_field || fieldConfig.request_field
    // create sort string
    return `${sortField}:${orderField}`
  }

  const sorts = []

  if (config.paginate.sort && config.paginate.sort.field) {
    sorts.push(sortResolve(config.paginate.sort))
  }

  // second sort
  if (config.paginate.sort2 && config.paginate.sort2.field) {
    sorts.push(sortResolve(config.paginate.sort2))
  }

  opts.sort = sorts.join(',')
  opts.total = true

  // get list column ready to view
  // only get column visible
  const querySelected = selectedColumns
    // extract request_field from column_map
    .map(
      col =>
        config.column_map[col].graph_field ||
        config.column_map[col].request_field,
    )
    // join to list field
    .join(' ')

  // resync case
  // not use page option , we use start option
  // limit now = current page (from dataset) * limit (from dataset)
  // we will have large data rows with total match current total data in dataset
  // fornow dataset only support continuasly loading, (not separate page)
  // so offset always start from 0
  if (resync && config.paginate.page > 1) {
    opts.start = 0
    opts.limit = config.paginate.page * config.paginate.limit
  }
  // normarl request should be follow current page
  else {
    opts.page = config.paginate.page
    opts.limit = config.paginate.limit || 30
  }

  // fetch data
  const result = await source(
    config,
    opts,
    queryVarDefine,
    queryVarUse,
    querySelected,
  )

  if (result.$$issue === true) {
    console.log('Failed inside dataset graphql connect')
    console.error(result)
    return false
  }

  // parse data
  return {
    total: result.meta.total,
    data: result.recordset,
  }
}

// get source action base on source type
export const getSourceAction = type => {
  if (type === 'GRAPHQL') return getGraphql
  if (type === 'HTTPSIMPLE') return getHttpSimple
  if (type === 'FILE') return getSourceFile
  if (type === 'ARRAY') return getArray
}
